import consola from'consola';export default defineNuxtPlugin(function(nuxtApp){nuxtApp.provide('consola',consola);});